import {V1OnshapeNameMappingIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import EnlilAxios from "../../../../util/EnlilAxios";


class OnshapeNameMappingEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        EnlilAxios({
            method: "GET",
            url: "t2/v1/onshape_name_mappings",
            json: true,
            params: {
                "Limit": pageSize,
                "Offset": (page - 1) * pageSize,
                "Sort": this.getFormattedSortSpecification(),
                ...this.getSearchSpecification(),
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.OnshapeNameMapping-001",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1OnshapeNameMappingIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.OnshapeNameMapping-001";
        payload.ShifamedMessage.OnshapeNameMapping = this.preparePUTPayload();

        return payload;
    };

    performUpdate() {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t2/v1/onshape_name_mappings",
            json: true,
            data: payload,
            headers: {},
        };
        this.notifyUpdateStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1OnshapeNameMappingIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let onshapeNameMapping = {};

        onshapeNameMapping["USID"] = this.getAttributeValue("USID");
        onshapeNameMapping["EmployeeUSID"] = this.getAttributeValue("EmployeeUSID");
        onshapeNameMapping["OnshapeEmail"] = this.getAttributeValue("OnshapeEmail");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.OnshapeNameMapping-001";
        payload.ShifamedMessage.OnshapeNameMapping = onshapeNameMapping;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t2/v1/onshape_name_mappings",
            json: true,
            data: payload,
            headers: {},
        };
        this.notifyInsertStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1OnshapeNameMappingIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentDeleteIDOC = () => {
        let payload = {};

        let onshapeNameMapping = {};

        onshapeNameMapping["USID"] = this.getAttributeValue("USID");

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.OnshapeNameMapping-001";
        payload.ShifamedMessage.OnshapeNameMapping = onshapeNameMapping;

        return payload;
    };

    performDelete() {
        let payload = this.enterpriseComponentDeleteIDOC();

        let options = {
            method: "DELETE",
            url: "t2/v1/onshape_name_mappings",
            json: true,
            data: payload,
            headers: {
                "idoc-request": this.getIDOCResponse() ?? "v1.OnshapeNameMapping-001",
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxios(options)
            .then(response => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default OnshapeNameMappingEnterpriseComponent;